import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";

export const ResourcesPage = () => {
  usePageViewAnalytics({ screen_name: "Resources" });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_RESOURCES" }));

  return (
    <PageContentWrapper>
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_RESOURCES} />
    </PageContentWrapper>
  );
};
